import { createConsoleLogger } from '@dossierhq/core';

const logger = createConsoleLogger(console);
export const FRONTEND_LOGGER = logger;
export const BACKEND_LOGGER = logger;
